import { client } from '../lib/client';

// 주소 검색 — 도로명·지번·건물명 통합 (서버가 카카오 로컬을 대신 호출한다)
// cancelToken: 입력이 바뀌어 더 필요 없어진 이전 요청을 취소한다
export const addressSearchAPI = ({ q, page = 1 }, cancelToken) => (
  client({
    url: '/v1/address/search',
    params: { q, page },
    cancelToken,
  })
);
